import {
  getApiV1AuthzOrganizationsByOrgIdMembersOptions,
  getApiV1UsersMeOptions,
} from "@/lib/api/@tanstack/react-query.gen";
import { PERSIST_MAX_AGE } from "@/lib/react-query-persist";

export function currentUserQueryOptions() {
  return {
    ...getApiV1UsersMeOptions(),
    meta: { persist: true },
    gcTime: PERSIST_MAX_AGE,
    staleTime: 60_000,
  };
}

export function orgMembersQueryOptions({
  organizationId,
}: {
  organizationId: number;
}) {
  return {
    ...getApiV1AuthzOrganizationsByOrgIdMembersOptions({
      path: { org_id: organizationId },
      query: { limit: "all" },
    }),
    meta: { persist: true },
    gcTime: PERSIST_MAX_AGE,
    staleTime: 60_000,
  };
}
